import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m8aq2q3qv8: FaireBrandEntity = {
  token: "b_m8aq2q3qv8",
  type: "brand",
  name: "Lily Clothing",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4b817f0f23453a72c044a63e7c2a6c7fe5247fd1893f5ad0a4856b59bbcb541.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ad5ccf005686ece335796db93069e11d79e27ce277f4e4fdc3c92a86cdb8e8a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a4b817f0f23453a72c044a63e7c2a6c7fe5247fd1893f5ad0a4856b59bbcb541.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ad5ccf005686ece335796db93069e11d79e27ce277f4e4fdc3c92a86cdb8e8a.png",
  location: "Whittier, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.1,
  reviewCount: 872,
  isInsider: true,
  description:
    "Lily Clothing is based in the heart of the fashion industry in Los Angeles. The company was founded in 2016 with an ambition to inspire and provide influential fashion to the world. Our brand is operated by professional design team, sewing team, and manufacture team.\nLily Clothing's highest goal is our customers' satisfaction with our high quality and well-designed clothing. We always try to provide high quality and the latest fashion apparels for our customers.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:09.221Z",
    importedBy: "entity-db-cli",
  },
};
